import { useState } from 'react';
import cx from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';

import { formatTokenAmount } from 'utils/amounts';
import { heightCollapse } from 'lib/framer-motion/height-collapse';

import {
  StyledBalance,
  StyledProject,
  StyledWrapper,
  StyledHeaderBalance,
  StyledHeaderProject,
  StyledHeaderWrapper,
  StyledHeaderButton,
  StyledContainer,
  StyledContentWrapper
} from './dropdown-projects-area.style';

import DropArrowIcon from 'components/icons/DropArrowIcon';

import { TokenProjectType } from 'types';

const DropdownProjectsArea = ({ options }) => {
  const [show, setToggle] = useState(false);

  if (options.length === 0) return null;

  const handleShow = () => {
    setToggle(!show);
  };

  return (
    <StyledContentWrapper>
      <StyledHeaderWrapper onClick={handleShow}>
        <StyledHeaderProject>Project(s) </StyledHeaderProject>

        {show && <StyledHeaderBalance>Balance</StyledHeaderBalance>}

        <StyledHeaderButton
          className={cx({
            active: !show
          })}
        >
          <DropArrowIcon />
        </StyledHeaderButton>
      </StyledHeaderWrapper>
      <AnimatePresence>
        {show && (
          <motion.div
            initial="from"
            animate="to"
            exit="from"
            variants={heightCollapse(0.1)}
          >
            <StyledContainer>
              {options.map((row: TokenProjectType) => (
                <StyledWrapper key={row.project_id}>
                  <StyledProject>{row.name}</StyledProject>
                  <StyledBalance>
                    {formatTokenAmount(row.balance, 24, 5)}
                  </StyledBalance>
                </StyledWrapper>
              ))}
            </StyledContainer>
          </motion.div>
        )}
      </AnimatePresence>
    </StyledContentWrapper>
  );
};

export default DropdownProjectsArea;
